export default {
  NAME_DOSE_NOT_EXIST: "نام وارد نشده است.",

  TYPE_ADVERTISE_DOSE_NOT_EXIST: "نوع تبلیغ وارد نشده است.",
  TYPE_ADVERTISE_INVALID: "نوع تبلیغ نامعتبر است..",

  LIST_SITES_DOSE_NOT_EXIST: "لیست سایت ها نمایش دهنده وارد نشده.",
  LIST_SITES_INVALID: "لیست سایت ها نمایش نامعتبر است.",

  AMOUNT_DOSE_NOT_EXIST: "مبلغ سایت نمایش دهنده وارد نشده.",
  AMOUNT_SITES_INVALID: "مبلغ سایت نمایش دهنده نامعتبر است.",

  SITE_LIST_DOSE_NOT_EXIST: "لیست سایت های نمایش دهنده وارد نشده.",
  SITE_LIST_INVALID: "لیست سایت های نمایش دهنده نامعتبر است.",

  START_DATE_IS_PAST_FROM_CURRENT_DATE: "تاریخ شروع از تاریخ جاری قبل تر است.",
  END_DATE_IS_PAST_FROM_START_DATE: "تاریخ پایان از تاریخ شروع قبل تر است.",
  
  START_DATE_IS_TOO_MUCH: "فاصله تاریخ شروع تا تاریخ جاری بیشتر از ۸۹ روز است.",
  END_DATE_IS_TOO_MUCH: "فاصله تاریخ پایان تا تاریخ جاری بیشتر از ۹۰ روز است.",

  COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER_IS_TOO_MUCH: "تعداد روزهای گروه نمایش دهنده بیشتر ۹۰ روز است.",
  
  CATEGORY_SITE_PUBLISHER_IDS_SELECTED_DOSE_NOT_SELECT: "دسته سایت های نمایش دهنده انتخاب نشده است.",
};
